import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const UpdateProperty = () => {
  const { selectedPropertyId } = useParams();
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [county, setCounty] = useState("");
  const PropertyId = localStorage.getItem("selectedPropertyId");
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Fetch property details
    if (token) {
      axios
        .get(
          `${StandardURL}/iNyumba/admin/properties/records/${PropertyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          const { title, description, location, county } =
            response.data.response;
          setProperty(response.data.response);
          setTitle(title);
          setDescription(description);
          setLocation(location);
          setCounty(county);
        })
        .catch((error) => {
          console.error("Error fetching property:", error);
        });
    }
  }, [selectedPropertyId]);

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    const token = localStorage.getItem("token");
    if (token) {
      axios
        .patch(
          `${StandardURL}/iNyumba/admin/properties/update/${PropertyId}`,
          {
            title,
            description,
            location,
            county,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          // Handle successful update
          toast.success(response.data.response);
          navigate(-1); // Go back one step in navigation
        })
        .catch((error) => {
          toast.error(error.response.data.response);
          console.error("Error updating property:", error);
        });
    }
  };

  const handleBack = () => {
    navigate(-1); // Navigates back to the previous page in history
  };

 return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100 flex items-center justify-center p-4 sm:p-6 lg:p-8">
          <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="max-w-2xl w-full bg-white p-8 sm:p-10 rounded-xl shadow-3xl border border-gray-200">
            <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center tracking-tight">
              Update Property Details 🏡
            </h1>
            <p className="text-center text-gray-600 mb-8 max-w-md mx-auto">
              Refine your property's information to ensure accuracy and attract the right tenants.
            </p>
            <hr className="my-6 border-gray-200" />

            {property ? ( // Ensure property data is available before rendering the form
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Title Input */}
                <div>
                  <label
                    htmlFor="title"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Property Title:
                  </label>
                  <input
                    type="text"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out placeholder-gray-400"
                    placeholder="e.g., Spacious Family Home with Garden"
                  />
                </div>

                {/* Description Textarea */}
                <div>
                  <label
                    htmlFor="description"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Description:
                  </label>
                  <textarea
                    id="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows="5"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out placeholder-gray-400 resize-y"
                    placeholder="Provide a detailed description highlighting key features, amenities, and nearby attractions..."
                  />
                </div>

                {/* Location Input */}
                <div>
                  <label
                    htmlFor="location"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Location:
                  </label>
                  <input
                    type="text"
                    id="location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out placeholder-gray-400"
                    placeholder="e.g., Westlands, Nairobi"
                  />
                </div>

                {/* County Input */}
                <div>
                  <label
                    htmlFor="county"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    County:
                  </label>
                  <input
                    type="text"
                    id="county"
                    value={county}
                    onChange={(e) => setCounty(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out placeholder-gray-400"
                    placeholder="e.g., Nairobi County"
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row justify-end gap-4 pt-4">
                  <button
                    type="submit"
                    className="flex items-center justify-center px-8 py-3 bg-blue-600 text-white font-bold rounded-lg shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                      <path
                        fillRule="evenodd"
                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Update Property
                  </button>

                  <button
                    type="button" // Important: use type="button" to prevent form submission
                    onClick={handleBack}
                    className="flex items-center justify-center px-8 py-3 bg-gray-500 text-white font-bold rounded-lg shadow-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Back
                  </button>
                </div>
              </form>
            ) : (
              // Display a message if property data is not yet loaded or is null
              <div className="text-center p-8 bg-gray-50 rounded-lg shadow-inner">
                <p className="text-xl text-gray-700 font-medium mb-4">
                  Property details not found or still loading.
                </p>
                <p className="text-md text-gray-500 mb-6">
                  Please ensure a property is selected to view and update its information.
                </p>
                <button
                    onClick={handleBack}
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-300 ease-in-out"
                >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Go Back
                </button>
              </div>
            )}
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default UpdateProperty;
